import "src/decidim/meetings/meetings_form"
import "src/decidim/meetings/meetings_polls"
import "src/decidim/forms/forms"

// Images
require.context("../images", true)

// CSS
import "stylesheets/decidim/meetings/meetings.scss"
